import { useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { NEXTJS_CALLS_HOME_RETAILER_APIS_SEARCH_250422 } from "@faire/web-api--source/indigofair/settings/NEXTJS_CALLS_HOME_RETAILER_APIS_SEARCH_250422";

export const useSettingHomeRetailerSearchAPIs = () =>
  useSetting(NEXTJS_CALLS_HOME_RETAILER_APIS_SEARCH_250422, false);
